
import { NewGymForm } from "../NewGymForm";

interface GymCreationSectionProps {
  isCreating: boolean;
  gymName: string;
  gymAddress: string;
  onSave: (name: string, address: string, logoFile: File | null) => Promise<void>;
  onCancel: () => void;
}

export const GymCreationSection = ({
  isCreating,
  gymName,
  gymAddress,
  onSave,
  onCancel,
}: GymCreationSectionProps) => {
  if (!isCreating) return null;

  return (
    <NewGymForm
      gymName={gymName}
      gymAddress={gymAddress}
      onSave={onSave}
      onCancel={onCancel}
    />
  );
};
